import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim is grounded in the real 2026-07-19 eval measurement (see metadata.md
// GROUNDING NOTE). Direct sequel to ep 43, which closed on "waiting to be measured"
// and "Proving it comes next." Tone: build-in-public, honest. This is a story about
// measurement honesty, not a quality win. No em-dashes. No invented numbers.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 5.0, caption: "Last episode I said the quality layer was live and waiting to be measured, and that proving it came next. This is that measurement." },
  { scene: "hook", fromSec: 5.8, holdSec: 3.9, caption: "It handed me a wrong number four separate times in one day, and every wrong number looked like a real finding." },
];

export const SPLIT: ScriptLine[] = [
  { scene: "split", fromSec: 0.4, holdSec: 6.2, caption: "The harness has one job. For every failure, decide whether the retriever failed, meaning the source was never fetched, or the generator failed, meaning the source was fetched and mishandled." },
  { scene: "split", fromSec: 7.0, holdSec: 3.4, caption: "That split gates a big, expensive piece of work I had already deferred once." },
];

export const ZERO: ScriptLine[] = [
  { scene: "zero", fromSec: 0.4, holdSec: 4.6, caption: "The first run came back at zero percent retriever side." },
  { scene: "zero", fromSec: 5.2, holdSec: 4.2, caption: "Read literally, retrieval is perfect and every failure is the model's fault. That would have killed the retrieval work." },
];

export const BUG1: ScriptLine[] = [
  { scene: "bug1", fromSec: 0.4, holdSec: 4.4, caption: "The first bug was that the gate could not see." },
  { scene: "bug1", fromSec: 5.0, holdSec: 5.4, caption: "The classifier can only prove a retriever miss when the case names the source that should have answered it, and zero of fifteen cases carried that label." },
  { scene: "bug1", fromSec: 10.6, holdSec: 3.4, caption: "Every failure fell to a conservative generator default. Once labelled, the number moved to fifty percent." },
];

export const BUG2: ScriptLine[] = [
  { scene: "bug2", fromSec: 0.4, holdSec: 5.8, caption: "The second bug was a corpus probe reading a column the table does not have, so it came back empty every single time." },
  { scene: "bug2", fromSec: 6.4, holdSec: 6.6, caption: "Sources that were sitting in the corpus got marked as never ingested, and those are dropped from the gate's maths. Fixing it moved the number to sixty-six point seven percent." },
];

export const BUG3: ScriptLine[] = [
  { scene: "bug3", fromSec: 0.4, holdSec: 6.2, caption: "The third bug was in the other half of the gate. The multi-hop metric returned false on every code path it had." },
  { scene: "bug3", fromSec: 6.8, holdSec: 6.7, caption: "It could only ever read zero point zero percent, and that is precisely the number the gate is written on. Making it real left the number there, but now it means something." },
];

export const BUG4: ScriptLine[] = [
  { scene: "bug4", fromSec: 0.4, holdSec: 5.6, caption: "The fourth bug was that my harness was stricter than my product. It fetched the top five results and stopped there." },
  { scene: "bug4", fromSec: 6.2, holdSec: 4.6, caption: "Production hands the model eight, fifteen or twenty results, depending on the question." },
  { scene: "bug4", fromSec: 11.0, holdSec: 4.5, caption: "Correct answers sitting at ranks six, ten and thirteen were counted as retrieval failures because the harness stopped at five." },
];

export const PUNCH: ScriptLine[] = [
  { scene: "punch", fromSec: 0.4, holdSec: 4.8, caption: "Fixing that put the split at sixty-two point five percent, and passing cases went from four of fifteen to seven of fifteen." },
  { scene: "punch", fromSec: 5.2, holdSec: 4.6, caption: "That fix changed no retrieval code. Production had always behaved that way, and the harness had been marking it wrong." },
  { scene: "punch", fromSec: 9.8, holdSec: 2.2, caption: "The numbers did not get better, the measurement got honest." },
];

export const VERDICT: ScriptLine[] = [
  { scene: "verdict", fromSec: 0.4, holdSec: 4.6, caption: "Sixty-two point five percent retriever side clears its bar, but the multi-hop half reads zero point zero percent." },
  { scene: "verdict", fromSec: 5.2, holdSec: 4.5, caption: "That is the half the gate is written on, so the expensive work stays deferred." },
  { scene: "verdict", fromSec: 9.7, holdSec: 4.8, caption: "These failures are first-hop. A multi-hop loop helps when a second source was never fetched, not when the first one was never found." },
];

export const LESSON: ScriptLine[] = [
  { scene: "lesson", fromSec: 0.4, holdSec: 5.0, caption: "A number is not trustworthy because it computes. It is trustworthy when the data underneath carries what its maths depends on." },
  { scene: "lesson", fromSec: 5.6, holdSec: 4.4, caption: "Four times in one day a number moved because the instrument changed, not because the product changed." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 6.1, caption: "Every broken version of that number looked exactly like a real finding." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
